import { ReplaySubject } from 'rxjs'
import { filter } from 'lodash-es'
import { map, take } from 'rxjs/operators'
import UserProvider from 'dashboard-js/providers/UserProvider'

const notifications = new ReplaySubject(1)

export default class {
    static start() {
        this.load()

        UserProvider.listen('NotificationSent', event =>
            this._mapNotifications(items => {
                items.unshift(event.notification)
                return items
            })
        )
    }

    static load() {
        axios.get('/api/notifications').then(response => {
            notifications.next(response.data.data)
        })
    }

    static markAsRead() {
        axios.put('/api/notifications/read').then(() =>
            this._mapNotifications(items =>
                items.map(notification => {
                    if (notification.read_at === null) {
                        notification.read_at = moment().format()
                    }
                    return notification
                })
            )
        )
    }

    static notifications() {
        return notifications
    }

    static unread() {
        return notifications.pipe(
            map(items => filter(items, notification => !notification.read_at))
        )
    }

    static _mapNotifications(map) {
        notifications.pipe(take(1)).subscribe(items => notifications.next(map(items)))
    }
}
